/** @jsx jsx */
import { Helmet } from 'react-helmet'
import { jsx } from 'theme-ui'
import { useReviews } from '~/hooks/components/use-reviews'

const StructuredData = ({ type, data, rating }) => {
  const { getAllStats } = useReviews()

  const structuredData = {
    '@context': 'https://schema.org/',
    '@type': type,
    ...data,
  }

  if (type === 'Product') {
    let ratingValue = rating?.score
    let reviewCount = rating?.count

    if (!ratingValue && !reviewCount) {
      const allStats = getAllStats()
      ratingValue = allStats?.score
      reviewCount = allStats?.count
    }

    if (ratingValue && reviewCount) {
      structuredData.aggregateRating = {
        '@type': 'AggregateRating',
        ratingValue: ratingValue && String(ratingValue.toFixed(1)),
        reviewCount: reviewCount && String(reviewCount),
      }
    }

    structuredData.brand = {
      '@type': 'Brand',
      name: 'Maker',
    }
  }

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  )
}

export default StructuredData
